module.exports = __webpack_public_path__ + "img/30.0b3e81c7.jpg";